// SEO Configuration for Sun Catchers Website
// Keys correspond to route paths without language prefix

export const SITE_NAME = 'SunCatchers';
export const SITE_URL = 'https://suncatchers.pt';
export const MEDIA_URL = 'https://media.suncatchers.pt';
export const DEFAULT_IMAGE = `${MEDIA_URL}/images/og/default-og-image.jpg`;

// Supported languages
export const SUPPORTED_LANGUAGES = ['en', 'pt', 'es', 'it'];
export const DEFAULT_LANGUAGE = 'en';

// Language-specific metadata for static pages
export const seoConfig = {
  home: {
    en: {
      title: 'Campervan Rental Portugal | Family & Surf Vans | SunCatchers',
      description: 'Rent eco-friendly solar-powered campervans in Portugal. Family vans for 5, surf vans with board storage. 24/7 support. Book from Lisbon area!',
    },
    pt: {
      title: 'Aluguer de Campervan Portugal | Vans Familiares & Surf | SunCatchers',
      description: 'Alugue campervans ecológicos movidos a energia solar em Portugal. Vans familiares para 5, vans de surf com arrumação de pranchas. Suporte 24/7!',
    },
    es: {
      title: 'Alquiler de Campervan Portugal | Furgonetas Familiares & Surf | SunCatchers',
      description: 'Alquila campervans ecológicos con energía solar en Portugal. Furgonetas familiares para 5, furgonetas de surf con almacenaje. Soporte 24/7!',
    },
    it: {
      title: 'Noleggio Campervan Portogallo | Van Familiari & Surf | SunCatchers',
      description: 'Noleggia campervan ecologici a energia solare in Portogallo. Van familiari per 5, van da surf con stivaggio tavole. Supporto 24/7!',
    },
  },
  catalog: {
    en: {
      title: 'Rent a Campervan in Portugal | 3 Unique Vans | SunCatchers',
      description: 'Choose from 3 unique campervans: Sun Catcher for couples, Wave Catcher for surfers, Swell Catcher for families. All solar-powered with hot water.',
    },
    pt: {
      title: 'Alugue uma Campervan em Portugal | 3 Vans Únicas | SunCatchers',
      description: 'Escolha entre 3 campervans únicas: Sun Catcher para casais, Wave Catcher para surfistas, Swell Catcher para famílias. Todas com energia solar.',
    },
    es: {
      title: 'Alquila una Campervan en Portugal | 3 Furgonetas Únicas | SunCatchers',
      description: 'Elige entre 3 campervans únicas: Sun Catcher para parejas, Wave Catcher para surfistas, Swell Catcher para familias. Todas con energía solar.',
    },
    it: {
      title: 'Noleggia un Campervan in Portogallo | 3 Van Unici | SunCatchers',
      description: 'Scegli tra 3 campervan unici: Sun Catcher per coppie, Wave Catcher per surfisti, Swell Catcher per famiglie. Tutti a energia solare.',
    },
  },
  'campervan/sun-catchers': {
    en: {
      title: 'Sun Catcher | 4-Person Campervan Rental | SunCatchers',
      description: 'Rent the Sun Catcher - our bright, solar-powered campervan for 4 people. Full kitchen, bathroom & comfortable beds. Perfect for couples and small families.',
    },
    pt: {
      title: 'Sun Catcher | Aluguer de Campervan para 4 Pessoas | SunCatchers',
      description: 'Alugue o Sun Catcher - a nossa campervan solar para 4 pessoas. Cozinha completa, casa de banho e camas confortáveis. Perfeito para casais.',
    },
    es: {
      title: 'Sun Catcher | Alquiler de Campervan para 4 Personas | SunCatchers',
      description: 'Alquila el Sun Catcher - nuestra campervan solar para 4 personas. Cocina completa, baño y camas cómodas. Perfecto para parejas y familias pequeñas.',
    },
    it: {
      title: 'Sun Catcher | Noleggio Campervan per 4 Persone | SunCatchers',
      description: 'Noleggia il Sun Catcher - il nostro campervan solare per 4 persone. Cucina completa, bagno e letti comodi. Perfetto per coppie e piccole famiglie.',
    },
  },
  'campervan/wave-catchers': {
    en: {
      title: 'Wave Catcher | Surf Campervan for 5 | SunCatchers',
      description: 'Surf campervan with interior board storage, wetsuit drying area & outdoor shower. Sleeps 5. Pop-up roof bed, diesel heater. From €60/day.',
    },
    pt: {
      title: 'Wave Catcher | Campervan de Surf para 5 | SunCatchers',
      description: 'Campervan de surf com arrumação interior para pranchas, área para secar fatos e duche exterior. Dorme 5. Teto pop-up, aquecedor a diesel.',
    },
    es: {
      title: 'Wave Catcher | Campervan de Surf para 5 | SunCatchers',
      description: 'Campervan de surf con almacenaje interior para tablas, zona para secar trajes y ducha exterior. Duerme 5. Techo elevable, calefacción diésel.',
    },
    it: {
      title: 'Wave Catcher | Campervan da Surf per 5 | SunCatchers',
      description: 'Campervan da surf con stivaggio interno per tavole, zona asciugatura mute e doccia esterna. Dorme 5. Tetto pop-up, riscaldamento diesel.',
    },
  },
  'campervan/family-catchers': {
    en: {
      title: 'Swell Catcher | Family Campervan for 5 | SunCatchers',
      description: 'Family campervan sleeping 5 people. Pop-up roof bed, hot water, full kitchen. Perfect for Portugal road trips with kids. From €60/day.',
    },
    pt: {
      title: 'Swell Catcher | Campervan Familiar para 5 | SunCatchers',
      description: 'Campervan familiar para 5 pessoas. Cama no teto pop-up, água quente, cozinha completa. Perfeito para viagens em família em Portugal.',
    },
    es: {
      title: 'Swell Catcher | Campervan Familiar para 5 | SunCatchers',
      description: 'Campervan familiar para 5 personas. Cama en techo elevable, agua caliente, cocina completa. Perfecto para viajes en familia por Portugal.',
    },
    it: {
      title: 'Swell Catcher | Campervan Familiare per 5 | SunCatchers',
      description: 'Campervan familiare per 5 persone. Letto nel tetto pop-up, acqua calda, cucina completa. Perfetto per viaggi in famiglia in Portogallo.',
    },
  },
  faq: {
    en: {
      title: 'Campervan Rental FAQ | SunCatchers Portugal',
      description: 'Common questions about renting a campervan in Portugal. Insurance, driving license, what\'s included, wild camping rules & more. Get answers here.',
    },
    pt: {
      title: 'FAQ Aluguer de Campervan | SunCatchers Portugal',
      description: 'Perguntas frequentes sobre aluguer de campervan em Portugal. Seguro, carta de condução, o que está incluído, regras de campismo selvagem e mais.',
    },
    es: {
      title: 'FAQ Alquiler de Campervan | SunCatchers Portugal',
      description: 'Preguntas frecuentes sobre alquiler de campervan en Portugal. Seguro, licencia de conducir, qué incluye, reglas de acampada libre y más.',
    },
    it: {
      title: 'FAQ Noleggio Campervan | SunCatchers Portogallo',
      description: 'Domande frequenti sul noleggio campervan in Portogallo. Assicurazione, patente, cosa è incluso, regole campeggio libero e altro.',
    },
  },
  about: {
    en: {
      title: 'About SunCatchers | Eco-Friendly Campervans Portugal',
      description: 'Meet the team behind SunCatchers. Our story, sustainable mission & commitment to eco-friendly campervan travel in Portugal.',
    },
    pt: {
      title: 'Sobre SunCatchers | Campervans Ecológicos Portugal',
      description: 'Conheça a equipa da SunCatchers. A nossa história, missão sustentável e compromisso com viagens ecológicas de campervan em Portugal.',
    },
    es: {
      title: 'Sobre SunCatchers | Campervans Ecológicos Portugal',
      description: 'Conoce al equipo de SunCatchers. Nuestra historia, misión sostenible y compromiso con viajes ecológicos en campervan por Portugal.',
    },
    it: {
      title: 'Chi Siamo SunCatchers | Campervan Ecologici Portogallo',
      description: 'Conosci il team di SunCatchers. La nostra storia, missione sostenibile e impegno per viaggi ecologici in campervan in Portogallo.',
    },
  },
  contact: {
    en: {
      title: 'Contact SunCatchers | Campervan Rental Lisbon',
      description: 'Contact SunCatchers for campervan rentals in Lisbon, Portugal. Located in Sintra. Call +351 925 025 908 or email info@suncatchers.pt.',
    },
    pt: {
      title: 'Contacte SunCatchers | Aluguer de Campervan Lisboa',
      description: 'Contacte a SunCatchers para aluguer de campervan em Lisboa, Portugal. Localizado em Sintra. Ligue +351 925 025 908 ou email info@suncatchers.pt.',
    },
    es: {
      title: 'Contacta SunCatchers | Alquiler de Campervan Lisboa',
      description: 'Contacta SunCatchers para alquiler de campervan en Lisboa, Portugal. Ubicado en Sintra. Llama +351 925 025 908 o email info@suncatchers.pt.',
    },
    it: {
      title: 'Contatta SunCatchers | Noleggio Campervan Lisbona',
      description: 'Contatta SunCatchers per noleggio campervan a Lisbona, Portogallo. Situato a Sintra. Chiama +351 925 025 908 o email info@suncatchers.pt.',
    },
  },
  blog: {
    en: {
      title: 'Van Life Blog | Portugal Travel Tips | SunCatchers',
      description: 'Discover Portugal van life tips, scenic routes, camping spots & travel guides. Expert advice for your campervan adventure.',
    },
    pt: {
      title: 'Blog Van Life | Dicas de Viagem Portugal | SunCatchers',
      description: 'Descubra dicas de van life em Portugal, rotas cénicas, spots de campismo e guias de viagem. Conselhos para a sua aventura de campervan.',
    },
    es: {
      title: 'Blog Van Life | Consejos de Viaje Portugal | SunCatchers',
      description: 'Descubre consejos de van life en Portugal, rutas escénicas, spots de camping y guías de viaje. Consejos para tu aventura en campervan.',
    },
    it: {
      title: 'Blog Van Life | Consigli di Viaggio Portogallo | SunCatchers',
      description: 'Scopri consigli di van life in Portogallo, percorsi panoramici, spot di campeggio e guide di viaggio. Consigli per la tua avventura in campervan.',
    },
  },
};

// Business information for LocalBusiness schema
export const businessInfo = {
  name: 'SunCatchers Campervans',
  legalName: 'SunCatchers Lda',
  description: 'Eco-friendly solar-powered campervan rentals in Portugal',
  url: SITE_URL,
  telephone: '+351925025908',
  email: 'info@suncatchers.pt',
  address: {
    streetAddress: 'Av. Pedro Álvares Cabral 147, Linhó',
    addressLocality: 'Sintra',
    addressRegion: 'Lisboa',
    postalCode: '2710-144',
    addressCountry: 'PT',
  },
  geo: {
    latitude: 38.7833,
    longitude: -9.3833,
  },
  priceRange: '€€',
  openingHours: 'Mo-Su 09:00-18:00',
  image: `${MEDIA_URL}/images/og/default-og-image.jpg`,
  sameAs: [
    'https://www.instagram.com/suncatchers.pt',
    'https://www.facebook.com/suncatchers.pt',
  ],
};
